export enum LeadStageEnum {
  UNREAD = 50,
  IN_PROGRESS = 100,
  NO_BUSINESS = 150,
  BUSINESS = 200,
  DUPLICATE = 250,
}
